import { FETCH_MENU_ITEMS, REFRESH_MENU } from './types';
import { api } from '../services/rest';

export const fetchMenuItems = (client, project) => dispatch => {
    api.get(`/Menu/Items/${client}/${project}`)
        .then(response => dispatch({
            type: FETCH_MENU_ITEMS,
            payload: response.data
        }));
};

export const refreshMenu = (id) => dispatch => {
    return dispatch({
        type: REFRESH_MENU, payload: id
    })
};
